import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

export const H1 = overrideOptional(styled.h1`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH1};
  font-family: ${theme.fontFamilyPrimary};
`)

export const H2 = overrideOptional(styled.h2`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH2};
  font-family: ${theme.fontFamilyPrimary};
`)

export const H3 = overrideOptional(styled.h3`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH3};
  font-family: ${theme.fontFamilyPrimary};
`)

export const H4 = overrideOptional(styled.h4`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH4};
  font-family: ${theme.fontFamilyPrimary};
`)

export const H5 = overrideOptional(styled.h5`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH5};
  font-family: ${theme.fontFamilyPrimary};
`)

export const H6 = overrideOptional(styled.h6`
  margin: 0.5rem 0;
  font-size: ${theme.fontSizeH6};
  font-family: ${theme.fontFamilyPrimary};
`)
